export const FeatureFlags = {
  DriverPerformance: 'release-driver-performance',
  SiteMaps: 'hal-10-10419-ui',
  RemoveGatesFromTaskTypes: 'release-remove-gates-from-task-types',
  DoorSelectionForDockGroups: 'release-door-selection-for-dock-groups',
  DriverDockGroups: 'release-driver-dock-group',
  LocationsHierarchy: 'hal-7-9218-ui',
  MessagesSideMenu: 'task-9741-s-8-ui',
  UseYardOpsApi: 'firefly-1-9758-ui',
  OccupiedDoors: 'vulcan-7723-s-9-ui',
  ImageCancelButton: 'image-capture-cancel-btn',
  ImageCaptureTasking: 'release-image-capture-tasking',
  GlobalUserSearch: 'release-global-user-search',
  NewLoginFlow: 'release-sso-auth-login',
  ReleaseAzureStorage: 'release-azure-sas-token',
  CarrierManagementImprovement: 'release-carrier-management-improvement',
  DisableImportTrailerBtn: 'temp-import-trailer-btn',
  ProductProtection: 'release-product-protection',
  PasswordRegex: 'release-password-regex',
  SiteDSTToggle: 'release-site-dst-toggle',
  AddOffsetToDates: 'release-convert-dates-with-offset',
  FiltersTooLong: 'release-use-trailers-doors-post-endpoints',
  LocationServices: 'release-location-services',
  ClearTasksFiltersOnLogout: 'release-delete-tasks-date-filters-on-logout',
  GateService: 'release-gate-service',
  AllowCreateAndStack: 'release-task-stacking',
  NormalDateRange: 'release-vulcan-13-11498-api',
  CannotEditSiteOnDeactivatedUser: 'release-cannot-edit-site-on-de-activated-user',
  TableSuppressVirtualisation: 'release-table-suppress-virtualisation',
};
